module.exports = __webpack_public_path__ + "static/media/radicals-custom.f51ee9e2.svg";